import { IsAdmin } from "../Helpers/Utilities";
import WebServiceWrapper from "./WebServiceWrapper";

export const DemographicService = {
    LoadData,
    SaveData
};
function LoadData(pid) {
    return WebServiceWrapper.Get(`/demographic/LoadData?patientId=${pid}&isAdmin=${IsAdmin()}`);
}
function SaveData(payload) {
    return WebServiceWrapper.Post("/demographic/SaveData", payload);
}